import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import SettingsStore from "../../stores/SettingsStore";

interface Props {
  className?: string;
  changePositionHandler?: (values: { top: number; left: number }) => void;
  enableScrollBar?: boolean;
  settingsStore?: SettingsStore;
  children: React.ReactNode;
}

const TableWrapper: React.FC<Props> = ({
  className,
  changePositionHandler,
  children,
  enableScrollBar = false,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!changePositionHandler) {
      return () => {
        window.removeEventListener("resize", () => {});
      };
    }

    let timeoutId: null | NodeJS.Timeout = null;

    const resizeListener = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(
        () =>
          changePositionHandler({
            top: ref.current?.offsetTop || 0,
            left: ref.current?.offsetLeft || 0,
          }),
        300
      );
    };

    resizeListener();

    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, [changePositionHandler]);

  return (
    <div
      ref={ref}
      className={classNames({
        [className || ""]: !!className,
        "declarant-table": true,
        "declarant-table--with-scrollbar": enableScrollBar,
      })}
    >
      {children}
    </div>
  );
};
export default TableWrapper;
